import gql from 'graphql-tag';
import entryPage, { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const TopicBaseFragment = gql`
  fragment TopicBaseFragment on topic_Entry {
    ... on topic_Entry {
      title
      uri
      slug
      id
      teaserText
      seoTopics
      image {
        ...CraftAssetFragment
      }
      children {
        title
        uri
        slug
      }
      categories: knowledgeCategories {
        title
        slug
      }
    }
  }
`;
const KnowledgeCategoriesFragment = gql`
  fragment KnowledgeCategoriesFragment on Query {
    categories: entries(site: [$site], section: "knowledgeCategories") {
      id
      title
      uri
      slug
    }
  }
`;
const KnowledgeTopicsFragment = gql`
  fragment KnowledgeTopicsFragment on Query {
    topics: entries(site: [$site], section: "knowledge", level: 2) {
      id
      title
      uri
    }
  }
`;
export const TopicQuery = gql`
  query TopicQuery($site: String!, $uri: String!, $slug: String!) {
    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
    entry(site: [$site], section: "knowledge", slug: [$slug]) {
      typeHandle
      ...EntryPageFragment
      ...TopicBaseFragment
      ... on topic_Entry {
        contentBlocks {
          ...ContentBlocksMatrixFragment
        }
        seoTopics
      }
    }
    ...KnowledgeTopicsFragment
    ...KnowledgeCategoriesFragment
  }
  ${EntryPageFragment}
  ${TopicBaseFragment}
  ${KnowledgeTopicsFragment}
  ${KnowledgeCategoriesFragment}
  ${SeomaticFragment}
  ${ContentBlocksMatrixFragment}
`;

export default {
  data() {
    return {};
  },

  mixins: [entryPage],

  methods: {
    setTopicCategories() {
      if (this?.entry?.categories) {
        const {
          params: { topic },
        } = this.$route;
        const categories = this.entry.categories.map((category) => ({
          ...category,
          route: {
            name: `knowledge-index-topic-category___${this.$i18n.locale}`,
            params: { topic, category: category.slug },
          },
        }));
        this.$emit('onCategories', categories);
      } else {
        console.warn('setTopicCategories: no categories found');
      }
    },
  },
};
